import { makeStyles } from "@material-ui/core/styles";

// D8.27.1 — Estilos de TicketsManagerTabs (chat).
export const useStyles = makeStyles(theme => ({
	ticketsWrapper: {
		position: "relative",
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflow: "hidden",
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		borderRadius:0,
	},

	ticketsContainer: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		height: "100%",
		minHeight: 0, // Importante para que flex funcione correctamente
		overflow: "hidden",
	},


	tabsHeader: {
		flex: "none",
		backgroundColor: theme.palette.tabHeaderBackground,
	},

	tabsInternal: {
		flex: "none",
		backgroundColor: theme.palette.tabHeaderBackground
	},

	settingsIcon: {
		alignSelf: "center",
		marginLeft: "auto",
		padding: 8,
	},
  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#1e3a8a",
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "#10b981",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#10b981",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "#ef4444",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "#ef4444",
      color: "#FFF",
    },
    borderRadius: 30,
  },

  // ✅ CORREGIDO: Estilos para el buscador dinámicos según tema
  searchInputWrapperNew: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
    borderRadius: "8px",
    padding: "8px 12px",
    margin: "8px",
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    transition: "all 0.3s ease",
    "&:focus-within": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#fff',
      boxShadow: theme.mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
    },
  },

  searchIconNew: {
    color: theme.palette.text.secondary || theme.palette.text.primary,
    marginRight: "8px",
    fontSize: "20px",
  },

  searchInputNew: {
    flex: 1,
    fontSize: "14px",
    color: theme.palette.text.primary,
    "& input": {
      padding: "4px 0",
      fontSize: "14px",
      color: theme.palette.text.primary,
    },
    "& input::placeholder": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      fontSize: "14px",
    },
  },

  searchSwitchNew: {
    marginLeft: "8px",
    "& .MuiSwitch-thumb": {
      width: "16px",
      height: "16px",
    },
    "& .MuiSwitch-track": {
      height: "12px",
      borderRadius: "6px",
    },
  },

  // ✅ CORREGIDO: Estilos para la barra de herramientas dinámicos según tema
  quickActionsBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#f8f9fa',
    borderBottom: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    minHeight: "56px",
  },

  quickActionsLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  quickActionsRight: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5), // ✅ Agregar espaciado entre botones
  },

  // ✅ CORREGIDO: QuickActionButton dinámico según tema
  quickActionButton: {
    minWidth: "40px",
    height: "40px",
    borderRadius: "8px",
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#fff',
    color: theme.palette.text.primary,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      borderColor: theme.palette.primary.main,
    },
  },

  // ✅ CORREGIDO: QuickActionIconButton dinámico según tema
  quickActionIconButton: {
    minWidth: "40px",
    height: "40px",
    borderRadius: "8px",
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#fff',
    color: theme.palette.text.primary,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      borderColor: theme.palette.primary.main,
    },
  },

	tab: {
		minWidth: 120,
		width: 120,
	},

	internalTab: {
		minWidth: 120,
		width: 120,
		padding: 5
	},

	ticketOptionsBox: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		background: theme.palette.optionsBackground,
		padding: theme.spacing(1),
	},

	ticketSearchLine: {
		padding: theme.spacing(1),
	},

	serachInputWrapper: {
		flex: 1,
		background: theme.palette.total,
		display: "flex",
		borderRadius: 40,
		padding: 4,
		marginRight: theme.spacing(1),
	},

	searchIcon: {
		color: "grey",
		marginLeft: 6,
		marginRight: 6,
		alignSelf: "center",
	},

	searchInput: {
		flex: 1,
		border: "none",
		borderRadius: 30,
	},

	insiderTabPanel: {
		height: '100%',
		marginTop: "-72px",
		paddingTop: "72px"
	},

	insiderDoubleTabPanel: {
		display:"flex",
		flexDirection: "column",
		marginTop: "-72px",
		paddingTop: "72px",
		height: "100%"
	},

	labelContainer: {
		width: "auto",
		padding: 0
	},
	iconLabelWrapper: {
		flexDirection: "row",
		'& > *:first-child': {
			marginBottom: '3px !important',
			marginRight: 16
		}
	},
	insiderTabLabel: {
		[theme.breakpoints.down(1600)]: {
			display:'none'
		}
	},
	smallFormControl: {
		'& .MuiOutlinedInput-input': {
			padding: "12px 10px",
		},
		'& .MuiInputLabel-outlined': {
			marginTop: "-6px"
		}
	}
}));
